import { Link } from 'react-router-dom';

export default function StickyCTA() {
  return (
    <>
      {/* Mobile Compact Sticky Bottom Bar (Visible on mobile screens < 768px) */}
      <aside
        aria-label="Hurtig kontakt"
        className="fixed bottom-0 inset-x-0 z-40 bg-maritime-950/95 backdrop-blur-md border-t border-maritime-800 px-4 py-2.5 flex items-center justify-between gap-3 shadow-2xl md:hidden"
      >
        <a
          href="tel:+4550510062"
          className="flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg bg-white/10 hover:bg-white/20 text-white text-xs font-semibold tracking-wide uppercase transition-colors whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-cyan-400"
          aria-label="Ring på telefon +45 50 51 00 62"
        >
          <i className="fa-solid fa-phone text-cyan-400 text-sm" aria-hidden="true" />
          <span className="whitespace-nowrap font-medium">Ring +45 50 51 00 62</span>
        </a>

        <Link
          to="/kontakt"
          className="flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white text-xs font-semibold tracking-wide uppercase transition-colors shadow-md whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-cyan-400"
        >
          <i className="fa-solid fa-paper-plane text-white text-xs" aria-hidden="true" />
          <span className="whitespace-nowrap font-medium">Kontakt</span>
        </Link>
      </aside>

      {/* Desktop Discrete Floating CTA (Visible on >= 768px) */}
      <aside
        aria-label="Hurtig kontakt desktop"
        className="hidden md:flex fixed bottom-6 right-6 z-40 items-center gap-2.5 bg-maritime-950/90 hover:bg-maritime-900 backdrop-blur-md text-white p-2 pr-4 rounded-full border border-maritime-700/80 shadow-2xl transition-all hover:scale-105 group"
      >
        <a
          href="tel:+4550510062"
          className="w-10 h-10 rounded-full bg-cyan-600 group-hover:bg-cyan-500 flex items-center justify-center text-white text-base shadow-md transition-all flex-shrink-0"
          title="Ring direkte til skipper"
          aria-label="Ring til JT transportsejlads"
        >
          <i className="fa-solid fa-phone animate-pulse" aria-hidden="true" />
        </a>

        <div className="flex flex-col text-left pr-1">
          <span className="text-[10px] uppercase font-bold tracking-wider text-cyan-400">
            Bådtransport på vandet
          </span>
          <a
            href="tel:+4550510062"
            className="text-xs font-semibold text-white group-hover:text-cyan-300 transition-colors whitespace-nowrap"
          >
            +45 50 51 00 62
          </a>
        </div>

        <Link
          to="/kontakt"
          className="ml-1 text-xs font-semibold px-3 py-1.5 rounded-full bg-white/10 hover:bg-cyan-600 text-slate-100 hover:text-white transition-colors whitespace-nowrap"
        >
          Få tilbud
        </Link>
      </aside>
    </>
  );
}
